import { render, staticRenderFns } from "./PopupContent.vue?vue&type=template&id=531c9378&"
import script from "./PopupContent.vue?vue&type=script&lang=js&"
export * from "./PopupContent.vue?vue&type=script&lang=js&"
import style0 from "./PopupContent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports